'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var Bacon, CACHE, DEL, GET, POST, PUT, R, checkResponseStatus, createResource, deleteResource, findResourceLink, integrationUrl, jsonHeaders, loadJSON, loadResourceFromParamsURLWithCache, loadResourceFromURLWithCache, log, nclog, processJSONWithStatus, removeSchema, renameProp, responseToJSON, simulateErrors, toJSON, updateResource, withRetry;

Bacon = require('baconjs');

R = require('ramda');

CACHE = require('./cache');

simulateErrors = false;

toJSON = function toJSON(response) {
  return response.json();
};

responseToJSON = function responseToJSON(response) {
  return Bacon.fromPromise(response.json()).mapError(R.always({}));
};

checkResponseStatus = function checkResponseStatus(data) {
  if (!data.success) {
    return new Bacon.Error(R.prop('message', data) || R.path(['error', 'message'], data) || data);
  } else {
    return new Bacon.Next(data);
  }
};

jsonHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json; charset=utf-8'
};

removeSchema = function removeSchema(url) {
  if (!!window.document) {
    return url.replace(/^http:/, '');
  } else {
    return url;
  }
};

loadJSON = function loadJSON(url) {
  return Bacon.fromPromise(fetch(removeSchema(url))).flatMap(responseToJSON);
};

log = R.curry(function (start, label, params, value) {
  var duration;
  if (__DEV__) {
    duration = new Date() - start;
    console.log('[' + duration + 'ms] - ', label, params, value);
  }
  return value;
});

withRetry = function withRetry(method, url, source) {
  // console.log "withRetry", method, url
  return Bacon.retry({
    source: source,
    retries: 5,
    isRetryable: function isRetryable(error) {
      var errorPayload, statusCode;
      statusCode = R.path(['status', 'code'], error);
      if (statusCode && statusCode !== 401 || !!error.httpStatusCode && error.httpStatusCode !== 401) {
        errorPayload = {
          resource: { method: method, url: url },
          error: {
            code: error.httpStatusCode,
            status: statusCode,
            raw: error
          }
        };
        if (!!window && window.Bugsnag && window.Bugsnag.notify) {
          Bugsnag.notify("Network Issue (retrying)", errorPayload);
        }
        if (!!window && window.console && window.console.error) {
          console.error("Network Issue (retrying)", errorPayload);
        }
        return true;
      } else {
        return false;
      }
    },
    delay: function delay(_ref) {
      var error = _ref.error,
          retriesDone = _ref.retriesDone;

      return retriesDone * 100;
    }
  });
};

loadResourceFromParamsURLWithCache = function loadResourceFromParamsURLWithCache(params) {
  return GET(params).flatMap(checkResponseStatus);
};

loadResourceFromURLWithCache = function loadResourceFromURLWithCache(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return GET(url, params).flatMap(checkResponseStatus);
};

createResource = function createResource(params) {
  return POST(params).flatMap(checkResponseStatus);
};

updateResource = function updateResource(params) {
  return PUT(params).flatMap(checkResponseStatus);
};

deleteResource = function deleteResource(params) {
  return DEL(params).flatMap(checkResponseStatus);
};

findResourceLink = R.curry(function (resourceName, method, data) {
  var link;
  link = R.find(function (resource) {
    var methods;
    methods = R.defaultTo(R.of(resource.method), resource.methods);
    return resource.name === resourceName && R.contains(method, methods);
  }, data.links);
  if (link) {
    if (__DEV__ && !link.url) {
      console.warn('findResourceLink for ' + resourceName + ', ' + method + ', ' + data + ' is null');
    }
    return link.url;
  }
});

renameProp = R.curry(function (oldName, newName, obj) {
  var value;
  value = R.prop(oldName, obj);
  return R.assoc(newName, value, R.dissoc(oldName, obj));
});

nclog = R.curry(function (label, val) {
  console.info(label, val);
  return val;
});

processJSONWithStatus = function processJSONWithStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return responseToJSON(response).flatMap(function (data) {
      return new Bacon.Next(data);
    });
  } else {
    return responseToJSON(response).flatMap(function (data) {
      return new Bacon.Error(data);
    });
  }
};

GET = function GET(urlOrParams) {
  var addParam, params, url;
  addParam = function addParam(sum, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        val = _ref3[1];

    var param;
    param = key + '=' + encodeURIComponent(val);
    return sum + (sum.length > 1 ? "&" + param : param);
  };
  if (R.is(String, urlOrParams)) {
    url = urlOrParams;
  } else {
    params = R.dissoc('url', urlOrParams);
    url = urlOrParams.url + R.reduce(addParam, "?", R.toPairs(params));
  }
  return withRetry("GET", url, function () {
    return Bacon.fromPromise(fetch(removeSchema(url), {
      method: 'GET',
      headers: jsonHeaders,
      credentials: 'include'
    }));
  }).flatMap(processJSONWithStatus).map(log(new Date(), 'GET ' + url, {}));
};

PUT = function PUT(params) {
  return withRetry("PUT", params.url, function () {
    return Bacon.fromPromise(fetch(removeSchema(params.url), {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify(R.dissoc('url', params))
    }), {
      credentials: 'include'
    });
  }).flatMap(processJSONWithStatus).map(log(new Date(), 'PUT ' + params.url, params));
};

POST = function POST(params) {
  return withRetry("POST", params.url, function () {
    return Bacon.fromPromise(fetch(removeSchema(params.url), {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(R.dissoc('url', params))
    }), {
      credentials: 'include'
    });
  }).flatMap(processJSONWithStatus).map(log(new Date(), 'POST ' + params.url, params));
};

DEL = function DEL(params) {
  return withRetry("DELETE", params.url, function () {
    return Bacon.fromPromise(fetch(removeSchema(params.url), {
      method: 'DELETE',
      headers: jsonHeaders,
      credentials: 'include',
      body: JSON.stringify(R.dissoc('url', params))
    }));
  }).flatMap(processJSONWithStatus).map(log(new Date(), 'DELETE ' + params.url, params));
};

integrationUrl = function integrationUrl() {
  var appUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var url;
  url = R.path(['location', 'href'], window || {});
  if (url) {
    url = url.replace(/autologin-provider.*?($|&)/, '').replace(/autologin-secret-key.*?($|&)/, '');
    return R.nth(0, url.split(/#/)) + appUrl;
  }
};

module.exports = {
  get: GET,
  put: PUT,
  post: POST,
  delete: DEL,
  loadJSON: loadJSON,
  loadResourceFromURL: loadResourceFromURLWithCache,
  loadResourceFromURLWithParams: loadResourceFromParamsURLWithCache,
  // loadResourceFromURL: loadResourceFromURL
  createResource: createResource,
  updateResource: updateResource,
  deleteResource: deleteResource,
  findResourceLink: findResourceLink,
  renameProp: renameProp,
  nclog: nclog,
  removeSchema: removeSchema,
  integrationUrl: integrationUrl,
  setClientInfo: function setClientInfo(app, channel) {
    return jsonHeaders = R.merge(jsonHeaders, {
      'Z-Client-App': app,
      'Z-Client-Channel': channel
    });
  }
};